import { Component } from '@angular/core';

@Component({
  selector: 'app-beneficios',
  imports: [],
  templateUrl: './beneficios.component.html',
  styleUrl: './beneficios.component.scss'
})
export class BeneficiosComponent {

}
